import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { useGetPriorities } from "security-app/hooks/useInvestigationsAPI";
import useUsersAndTeams from "security-app/components/Investigations/hooks/useUsersAndTeams";
import { Icon } from "components/common";
import { Label } from "components/bootstrap";
const ICON_TYPES = {
  team: "group",
  user: "person"
};
const Container = styled.div`
  display: flex;
  gap: 16px;
`;
const MainDetailContainer = styled.div`
  display: flex;
  gap: 8px;
  line-height: 1;
`;
const DetailLabel = styled(Label)`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-weight: bold;
`;
const AssigneeIcon = styled(Icon)`
  width: 15px;
  margin-right: 2px;
  vertical-align: middle;
`;
const MainDetail = ({ label, value }) => /* @__PURE__ */ React.createElement(MainDetailContainer, null, label, " ", /* @__PURE__ */ React.createElement(DetailLabel, { bsStyle: "default" }, value != null ? value : "none"));
const Priority = ({ priority }) => {
  const { priorities } = useGetPriorities(true);
  const priorityText = useMemo(
    () => {
      var _a;
      return (_a = priorities.find((prio) => prio.priority === priority)) == null ? void 0 : _a.text;
    },
    [priorities, priority]
  );
  return /* @__PURE__ */ React.createElement(MainDetail, { label: "Priority", value: priorityText });
};
const AssignedTo = ({ assignedTo }) => {
  var _a, _b;
  const usersAndTeams = useUsersAndTeams();
  const assignee = (_a = usersAndTeams[assignedTo]) == null ? void 0 : _a.label;
  return /* @__PURE__ */ React.createElement(
    MainDetail,
    {
      label: "Assigned to",
      value: /* @__PURE__ */ React.createElement(React.Fragment, null, assignee && /* @__PURE__ */ React.createElement(AssigneeIcon, { name: ICON_TYPES[(_b = usersAndTeams[assignedTo]) == null ? void 0 : _b.type], size: "xs" }), assignee != null ? assignee : "unassigned")
    }
  );
};
const MainDetails = ({ priority, status, assignedTo }) => /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Priority, { priority }), /* @__PURE__ */ React.createElement(MainDetail, { label: "Status", value: status }), /* @__PURE__ */ React.createElement(AssignedTo, { assignedTo }));
export default MainDetails;
